<template>
  <router-view />
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { appPerfMark, appPerfSinceMyProfile, appPerfScheduleFirstPaint } from '@/utils/appBootstrapPerfLog.js';
export default {
  data: () => ({}),

  computed: {
    ...mapGetters({ isLogin: 'user/isLogined' }),
    // ...mapGetters({ isAuthTokenExpired: "user/isAuthTokenExpired" }),
    ...mapGetters({ userProfile: 'user/getUserProfile' }),
    ...mapGetters({ getShowExplorer: 'explorer/getShowExplorer' })
  },

  watch: {
    // isLogin(logined) {
    //   if (logined) {
    //     console.log("isLogin watch login", logined);
    //     this.$router.push("/dashboard");
    //   } else {
    //     console.log("isLogin watch login", logined);
    //     this.$router.push("/login");
    //   }
    // },
    // isAuthTokenExpired(isExpired) {
    //   console.log("main.vue isAuthTokenExpired", isExpired);
    //   if (isExpired) {
    //     //현재라우터가 로그인이 아니라면 로그인으로 이동
    //     if (this.$route.path !== "/login") {
    //       this.$router.push("/login");
    //     }
    //   }
    //  else {
    //   if (isExpired !== null && isExpired === false) {
    //     this.$router.push("/dashboard");
    //   }
    // }
    // },
  },

  mounted() {
    appPerfMark('MainPage:mounted', { path: this.$route?.path });
    appPerfSinceMyProfile('MainPage:mounted');
    appPerfScheduleFirstPaint('MainPage');
    // TODO: 서버에 로그인 상태를 확인한다.
    // if 로그인 인증 성공 => this.$router.push('/dashboard');
    // else 로그인 인증 실패 => this.$router.push('/login');

    // 현재 상태가 로그인 된 상태가 아니라면 로그인으로 돌려보냅니다.
    // 로그인페이지에서 토큰은 제거되므로 재로그인이 필요한 상태가 됩니다.

    //토큰x
    /** -counterpencil- authToken이 json 형식이 아니라 string 형식이라고 에러가 발생하여서 아래와같이 처리했습니다. */
    this.checkAuth();

    // if (!this.isLogin) {
    //   this.$router.push("/login");
    // } else {
    //   this.$router.push("/dashboard");
    // }
  },

  methods: {
    ...mapActions({
      toggleActive: 'explorer/toggleActive',
      setReportName: 'explorer/setReportName',
      setShowExplorer: 'explorer/setShowExplorer',
      setMapMenu: 'explorer/setMapMenu',
      resetState: 'explorer/resetState'
    }),
    resetExplorerStore() {
      this.setReportName('');
      console.log('mounted', this.getReportId);
      if (this.getReportId) {
        this.toggleActive({
          projectId: '',
          siteId: '',
          dayName: '',
          reportId: this.getReportId
        });
      }
      //지도의 메뉴닫기
      this.setMapMenu(false);
      //report 탐색기 닫기
      this.setShowExplorer(true);
    },
    async checkAuth() {
      //토큰있으면 /dashboard
      //아니면 /login

      if (window.location.pathname === '/') {
        this.resetExplorerStore();
        //report id 가 없으면 dashboard 페이지로 이동
        this.$router.push({ name: 'dashboard' });
      }
      return;
    }
  }
};
</script>
